import { render, staticRenderFns } from "./TransferButton.vue?vue&type=template&id=57e48bf8&"
import script from "./TransferButton.vue?vue&type=script&lang=ts&"
export * from "./TransferButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports